export default __webpack_public_path__ + "static/Letter_of_Recommendation-a409aadfeb983f32de5c508a8be20f38.pdf";